import React from "react";
import { useQuery } from "react-query";
import logoImg from '../../static/images/logo.png';
import { fetchNews } from "../../services/userServices";
import SimpleSpinner from "../Loader/SimpleSpinner";
import NewsItem from "./NewsItem";
import { BASE_WEB_URL } from "../../CONSTANTS";
const size = 5;
const queryOptions = { refetchOnMount: false, refetchOnWindowFocus: false };
export default function News() {
  const { isLoading, data, error } = useQuery("news", fetchNews, queryOptions);

  return (
    <div className="news-section">
      {isLoading && !data && <SimpleSpinner topCenter />}
      {data && (
        <>
          <div className="news-heading-main">
            <h2>اخر الاستفتاءات في المجلس الاتحادي</h2>
          </div>
          <div className="news-items">
            {data.slice(0, size).map((news, i) => {
              let imageCover = logoImg;
              
              if(news.topic_assets.length > 0){
                const index = news.topic_assets.findIndex(el => el.asset_type === 'png')
                if(index > -1){
                  imageCover = BASE_WEB_URL +  news.topic_assets[index]
                }
              }
              return (
                <NewsItem
                  image_url={imageCover}
                  heading={news.title}
                  id={news.id}
                  key={i}
                />
              );
            }
            )}
          </div>
        </>
      )}
      {error && <h3 className="error-text">{error.message}</h3>}
    </div>
  );
}
